import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const REPORT_MENU_API = `${API_URL}/superset/embed-configs`

export const service = {
  getReportMenuData: (params: ParamsModel) => {
    return axios.get(REPORT_MENU_API, {params})
  },

  addReportMenu: (data: any) => {
    return axios.post(REPORT_MENU_API, data)
  },

  updateReportMenu: (data: any, id: string) => {
    return axios.patch(`${REPORT_MENU_API}/${id}`, data)
  },

  deleteReportMenu: (id: string) => {
    return axios.delete(`${REPORT_MENU_API}/${id}`)
  },

  singleEnableReportMenu: (id: string) => {
    return axios.patch(`${REPORT_MENU_API}/${id}`, {is_active: true})
  },

  singleDisableReportMenu: (id: string) => {
    return axios.patch(`${REPORT_MENU_API}/${id}`, {is_active: false})
  },
}
